<template>
  <div v-on="$listeners"
       :style="style">
    <slot />
  </div>
</template>

<script>
  import { FontStyle } from '@js/styles'

  export default {
    name: 'TextNoResult',
    inheritAttrs: false,
    data: function () {
      return {
        style: {
          fontFamily: FontStyle.family.primary,
          fontSize: FontStyle.size.lg,
          fontWeight: FontStyle.weight.md,
          textAlign: 'center',
        },
      };
    },
    created: function () {
      this.style = {
        ...this.style,
        ...this.$attrs,
      };
    },
  };
</script>
